<template>
    <DetailPembayaran jenisPembayaran="PP" />
</template>

<script>

import DetailPembayaran from '../../components/pembayaran/DetailPembayaran'

export default {
    name: 'pelunasan-pembayaran',
    components: {
        DetailPembayaran,
    }
}
</script>